@use "../../variables" as *;

$searchButton-left: 20px;
$searchButton-right: 6px;
$searchButton-width: 35px;

.searchSection form {
  margin: 0;
  padding-bottom: 25px;
}

.searchSection {
  position: relative;
  width: 100%;
  padding-top: 48px; // reserve space for error text above the search box

  .errorMessage {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    font-size: 14px;
    text-align: center;
    letter-spacing: 0.42px;
    padding-left: 20px;
    padding-right: 20px;
    overflow-wrap: break-word;
    word-break: break-word;
    z-index: 1;
  }

  .searchboxContainer {
    position: relative;
    z-index: 2;
    text-align: center;
    margin: auto;
    width: calc(100% - 40px);
    max-width: 640px;
    border-radius: $search-grid-border-radius;
    border: 1px solid $search-box-grey;
    height: 50px;
    background-color: $search-box-grey;

    .searchbox {
      position: relative;
      height: 50px;
      overflow: hidden;

      .searchButton,
      .searchInput {
        vertical-align: top;
        height: 50px;
        background-color: transparent;
        border: none;
        outline: none;
        border-radius: 0;
        text-align: center;

        &::-ms-clear {
          display: none;
        }
      }

      .searchButton {
        position: absolute;
        right: $searchButton-right;
        padding: 0;
        cursor: pointer;
        z-index: 1;

        svg {
          width: $searchButton-width;

          &.search-2021-icon {
            display: inline;
            height: 24px;
          }
        }
      }

      .transitionWrapper {
        display: inline-block;
        text-align: left;
        width: 100%;
        height: inherit;

        .inputSizer {
          display: block;
          height: 100%;
          padding-left: $searchButton-left + $searchButton-width;
          padding-right: $searchButton-left + $searchButton-width;

          .searchInput {
            padding: 1px 2px;

            &::placeholder {
              color: $es-all-black;
            }
          }

          .searchInput,
          &::after {
            width: 100%;
            overflow: hidden;
            grid-area: 1 / 2;
            font-size: 17px;
          }

          &::after {
            content: attr(data-value) " ";
            visibility: hidden;
            white-space: pre-wrap;
          }
        }
      }
    }

    &.focus {
      background-color: $es-white;
      border-color: $search-box-grey;
      border-radius: $search-grid-border-radius;

      .searchbox {
        .transitionWrapper {
          .inputSizer {
            display: inline-block;
            width: 100%;
            transform: translateX(0);
            padding-left: $search-grid-side-padding;

            .searchInput {
              text-align: left;
              border: none;
              outline: none;

              &::after {
                color: $es-black;
                padding-left: 0;
                padding-right: 0;
              }
            }
          }
        }
      }
    }
  }
}
